// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.roles', {
        url: '/roles',
        views: {
            "contactList@contacts": {
                templateUrl: 'main/contacts/roles/roles.tpl.html',
                controller: 'RolesController as vm'
            }
        },
        resolve: {
            roles: rolesResolver
        }
    });
}

//@ngInject
function rolesResolver(RolesApiService) {
    return RolesApiService.getAllRoles();
}

//@ngInject
function RolesController($state, roles, RolesApiService, AuthService) {
    var vm = this;

    vm.searchTerm = "";
    vm.roles = roles;
    vm.selectedRoleId = 0;

    vm.selectRole = selectRole;

    activate();

    function activate() {

    }

    function selectRole(role) {
        if (AuthService.canAccess('role', 'read')) {
            $state.go('contacts.roles.role', {roleId: role.id});
        }
    }
}

angular.module('contacts.roles', ['roles.api','contacts.roles.role'])
    .config(stateConfig)
    .controller('RolesController', RolesController);
